import { useEffect } from "react";

/**
 * The Rubik's Cube experience lives as a single self-contained HTML file at
 * /cube.html (see /app/frontend/public/cube.html). To keep the preview URL
 * pointing straight at the cube, we simply redirect the React root to it.
 */
function App() {
  useEffect(() => {
    window.location.replace("/cube.html");
  }, []);

  return (
    <div
      data-testid="cube-redirect"
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg,#eef1f5,#f7f8fb)",
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        fontSize: 12,
        letterSpacing: "0.2em",
        textTransform: "uppercase",
        color: "#3a3f47",
      }}
    >
      Loading Studio…
    </div>
  );
}

export default App;
